<template>
  <router-link 
    :to="leagueUrl"
    :class="linkClasses"
    @click="handleClick"
  >
    <slot :league="league" :leagueId="leagueId" :isValid="isValid">
      {{ league.league_name }}
    </slot>
  </router-link>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getLeagueId, getLeagueRoute, hasValidLeagueId } from '../utils/leagueUtils'

const props = defineProps({
  league: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  baseClasses: {
    type: String,
    default: 'flex items-center p-3 rounded-xl transition-all duration-200 ease-in-out'
  },
  activeClasses: {
    type: String,
    default: 'bg-gradient-to-r from-pink-50 to-pink-100 text-pink-600 shadow-sm'
  },
  inactiveClasses: {
    type: String,
    default: 'text-gray-700 hover:bg-gray-200 hover:shadow-sm'
  },
  disabledClasses: {
    type: String,
    default: 'text-gray-400 cursor-not-allowed opacity-50'
  }
})

const emit = defineEmits(['click'])

const route = useRoute()

const leagueId = computed(() => getLeagueId(props.league))
const leagueUrl = computed(() => getLeagueRoute(props.league) || '#')
const isValid = computed(() => hasValidLeagueId(props.league))
const isActive = computed(() => route.params.id === leagueId.value?.toString())

const linkClasses = computed(() => {
  if (!isValid.value || props.disabled) {
    return [props.baseClasses, props.disabledClasses]
  }
  return [
    props.baseClasses,
    isActive.value ? props.activeClasses : props.inactiveClasses
  ]
})

const handleClick = (event) => {
  if (!isValid.value || props.disabled) {
    event.preventDefault()
    if (!isValid.value) {
      console.warn('Cannot navigate to league without valid ID:', props.league)
    }
    if (props.disabled) {
      console.log('Click prevented - component is disabled')
    }
    return
  }
  emit('click', props.league)
}
</script> 